import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'
import { cloneDeep } from 'lodash-es'
import { message as DcMessage } from '@dc-platform/dc-components'
import { saveLabel, updateLabel } from '@/api/yuntuSales/labelManage'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'


const __default__ = { name: 'LabelEditModal' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const labelTypeEnum = [
  {
    value: 0,
    label: '普通标签'
  },
  {
    value: 1,
    label: '特殊标签'
  }
]

const title = ref<string>()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const initForm = { parentId: -1, parentName: '无' }
const dataForm = ref<any>(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  labelName: [{ required: true, message: '请输入标签名称' }],
  labelType: [{ required: true, message: '请选择类型' }]
}

watch(
  () => visible.value,
  (val) => {
    if (!val) {
      formRef.value?.resetFields()
      dataForm.value = cloneDeep(initForm)
    }
  }
)

const init = (data: any, parent?: any) => {
  if (data) {
    title.value = '编辑'
    dataForm.value.parentId = data.parentId
    dataForm.value.parentName = data.parentName
    dataForm.value.labelName = data.name
    dataForm.value.labelType = data.labelType
    dataForm.value.status = data.status
    dataForm.value.sort = data.weight
    dataForm.value.comment = data.comment
    dataForm.value.appId = data.appId
    dataForm.value.labelId = data.id
  } else {
    title.value = '新增'
    if (parent) {
      dataForm.value.parentId = parent.id
      dataForm.value.parentName = parent.name
    }
  }
  visible.value = true
}

const emit = __emit
const handleOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    const params = Object.assign({}, dataForm.value)
    if (dataForm.value.labelId) {
      updateLabel(params)
        .then(() => {
          DcMessage.success(`${title.value}成功`)
          formRef.value?.resetFields()
          visible.value = false
          emit('fetch')
        })
        .finally(() => {
          loading.value = false
        })
    } else {
      params.appId = 'cos_lbu'
      params.status = 0
      saveLabel(params)
        .then(() => {
          DcMessage.success(`${title.value}成功`)
          formRef.value?.resetFields()
          visible.value = false
          emit('fetch')
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
    title: title.value,
    width: "670px",
    "confirm-loading": loading.value,
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: dataForm.value,
        ref_key: "formRef",
        ref: formRef,
        rules: formRules,
        "wrapper-col": { span: 24 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dc_form_item, {
            name: "parentName",
            label: "上级标签",
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: dataForm.value.parentName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.parentName) = $event)),
                disabled: true,
                style: {"width":"100%"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, {
            name: "labelName",
            label: "标签名称",
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosInput, {
                value: dataForm.value.labelName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.labelName) = $event)),
                style: {"width":"100%"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, {
            label: "类型",
            name: "labelType",
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.value.labelType,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.labelType) = $event)),
                options: labelTypeEnum,
                placeholder: "请选择",
                allowClear: "",
                style: {"width":"100%"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "sort",
            label: "顺序",
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: dataForm.value.sort,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.value.sort) = $event)),
                style: {"width":"100%"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_dc_form_item, {
            name: "comment",
            label: "备注",
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: dataForm.value.comment,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.value.comment) = $event)),
                style: {"width":"100%"}
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "title", "confirm-loading"]))
}
}

})